import {
  type CampaignDraftCreatorItem,
  type CampaignDraftPostItem,
  type CampaignPostItem,
  type CreateCampaignRequest,
  buildCampaignTrackPostItem,
  classifyCreatorSource,
  isCampaignSupportedPlatform,
  splitTrackingTerms,
  toCampaignPlatform,
  createCampaignRequestBodySchema,
} from '@/entities/campaign';

import { buildCreatorPayloadItem } from '../../../hooks';

type BuildCampaignCreatePayloadArgs = {
  campaignEndDate?: DateISOString;
  campaignName: string;
  campaignStartDate: DateISOString;
  creatorItems: CampaignDraftCreatorItem[];
  creatorKeywords: string[];
  hasEndDate: boolean;
  postItems: CampaignDraftPostItem[];
};

export function buildCampaignCreatePayload(args: BuildCampaignCreatePayloadArgs) {
  const trackingTerms = splitTrackingTerms(args.creatorKeywords);
  const creatorPayloadItems = args.creatorItems.flatMap((item) => {
    const classification = classifyCreatorSource(item.sourceValue);
    if (!classification) return [];
    const payloadItem = buildCreatorPayloadItem(item, classification);
    return payloadItem ? [payloadItem] : [];
  });

  const postPayloadItems = args.postItems.flatMap((item): CampaignPostItem[] => {
    const payloadItem = buildCampaignTrackPostItem(item.postUrl);
    if (!payloadItem || !isCampaignSupportedPlatform(payloadItem.platform)) return [];
    return [{ ...payloadItem, platform: payloadItem.platform }];
  });

  const request = {
    name: args.campaignName.trim(),
    start_date: args.campaignStartDate,
    end_date: args.hasEndDate && args.campaignEndDate ? args.campaignEndDate : undefined,
    keywords: trackingTerms.keywords.length > 0 ? trackingTerms.keywords : undefined,
    hashtags: trackingTerms.hashtags.length > 0 ? trackingTerms.hashtags : undefined,
    mentions: trackingTerms.mentions.length > 0 ? trackingTerms.mentions : undefined,
    added_items: [...creatorPayloadItems, ...postPayloadItems].map((item) => ({
      ...item,
      platform: toCampaignPlatform(item.platform),
    })),
  } satisfies CreateCampaignRequest;

  createCampaignRequestBodySchema.parse(request);
  return request;
}
